import React from "react";
import useWindowWidth from "../../hooks/useWindowWidth";
import OverlayProductCardsForCarousel from "./OverlayProductCardsForCarousel";
import useWindowHeight from "../../hooks/useWindowHeight";

export default function ProductCardCarouselComponent() {
  const windowWidth = useWindowWidth();
  const windowHeight = useWindowHeight()

  return (
    <div style={{ height: windowHeight <= 745 ? "440px" : windowWidth <=1500 ? "500px":"600px", marginBottom:"20px" }}>
      <div
        style={{ textAlign: "center", color: "white", marginBottom: "30px" }}
      >
        <h4 style={{ fontSize: windowHeight <= 745 ? "20px" :windowWidth <=1500 ? "22px" :"30px" }}>Quotations, Just one click away</h4>
        <h6 style={{ fontSize: windowHeight <= 745 ? "12px": windowWidth <=1500 ? "14px" : "16px"}}>
          Easy request quotations via our portal with just
        </h6>
        <h6 style={{ fontSize: windowHeight <= 745 ? "12px": windowWidth <=1500 ? "14px" : "16px" }}>
          one click. Get accurate quotations in 24 hours.
        </h6>
      </div>
      <div style={{ display: "flex", justifyContent: "center", padding:"0px 50px" }}>
        <OverlayProductCardsForCarousel />
      </div>
    </div>
  );
}
